// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"wP-z","categoryName":"xP-z","categoryNameSearchHeader":"yP-z","categoryContent":"zP-z","bottomAligned":"AP-z","image":"BP-z","imageNoBackground":"CP-z"};